import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  input: {
    width: "100%",
    color: "#9D9D9D",
    "& input[type=number]": {
      "-moz-appearance": "textfield",
    },
    "& input[type=number]::-webkit-outer-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
    "& input[type=number]::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
    "& label.Mui-focused": {
      color: "#0068EF",
    },
    "& label.Mui-error": {
      color: "red",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#0068EF",
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      "&:hover fieldset": {
        borderColor: "#0068EF80",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#0068EF",
      },
      "&.Mui-focused": {
        boxShadow: "0 0 0 3px rgba(0, 104, 239, 0.1)",
      },
      "&.Mui-error fieldset": {
        borderColor: "red",
      },
    },
  },
  cardTextField: {
    width: "100%",
    color: "#9D9D9D !important",
    "& label.Mui-focused": {
      color: "#0068EF",
    },
    "& label.Mui-error": {
      color: "red",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#0068EF",
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      transition: "box-shadow 0.2s ease",
      "&:hover fieldset": {
        borderColor: "#0068EF80",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#0068EF",
      },
      "&.Mui-focused": {
        boxShadow: "0 0 0 3px rgba(0, 104, 239, 0.1)",
      },
      "&.Mui-error fieldset": {
        borderColor: "red",
      },
    },
  },
  savedCardGrid: {
    cursor: "pointer",
    marginTop: "10px",
    borderRadius: "12px !important",
    justifyContent: "space-between",
    alignItems: "center !important",
    display: "flex",
    position: "relative",
    border: "1.5px solid #e0e5ec",
    transition: "all 0.25s ease !important",
    backgroundColor: "#fff",
    "&:hover": {
      border: "1.5px solid #0068EF",
      boxShadow: "0 2px 8px rgba(0, 104, 239, 0.12)",
      "& $savedCardGridArrow": {
        color: "#0068EF",
      },
    },
  },
  savedCardGridArrow: {
    display: "flex",
    justifyContent: "end",
    padding: "0 5px",
    fontSize: "35px",
    transition: "color 0.2s ease",
  },
  subTitle: {
    marginTop: 20,
    fontWeight: "600 !important",
    color: "#1a1a2e !important",
    letterSpacing: "-0.2px",
  },
  cardDetailsFields: {
    width: "100%",
    borderRadius: "10px",
    border: "1.5px solid #e0e5ec !important",
    outline: "none !important",
    boxShadow: "none !important",
  },
  pricingBreakdown: {
    margin: "5px 0",
    border: "1.5px solid #e0e5ec",
    borderRadius: "12px",
    padding: "20px",
    textTransform: "capitalize",
  },
  pricingBreakdown_final: {
    color: "#0068EF !important",
  },
  pricingBreakdown_amount: {
    fontWeight: "bold",
  },
  payButton: {
    marginTop: "10px !important",
    width: "100%",
    maxWidth: 400,
    border: "none",
    outline: "none",
    boxShadow: "none !important",
    color: "#FFFFFF !important",
    fontWeight: "500 !important",
    borderRadius: "50px !important",
    textTransform: "none !important",
    fontSize: "14px !important",
    padding: "13px !important",
    transition: "opacity 0.2s ease !important",
    "&:hover": {
      opacity: 0.9,
    },
  },
}));

export default useStyles;
